// @ts-nocheck
import { takeLatest } from 'redux-saga/effects';
import {
	createFetchColumnsSaga,
	createFetchOrderDataSaga,
	createFetchAvailabilitySaga,
} from 'pages/orderShared/createOrderSagas';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import * as constants from './constants';

const handleFetchColumns = createFetchColumnsSaga({
	primaryGroupKey: 'sku',
	primaryKeywords: constants.COLUMN_SKU_KW,
	columnKeys: ['sku', 'store', 'warehouse', 'order'],
	logPrefix: '[OBS]',
	slice,
	constants,
});

const handleFetchOrderData = createFetchOrderDataSaga({
	selectRowKey: 'OrderDetailID',
	logPrefix: '[OBS]',
	slice,
	constants,
});

const handleFetchSkuAvailability = createFetchAvailabilitySaga({
	idField: 'skuId',
	logPrefix: '[OBS]',
	slice,
});

export default function* rootSaga() {
	return [
		yield takeLatest(sagaActions.fetchOrderColumns, handleFetchColumns),
		yield takeLatest(sagaActions.fetchOrderData, handleFetchOrderData),
		yield takeLatest(sagaActions.fetchSkuAvailability, handleFetchSkuAvailability),
	];
}
